import { render, staticRenderFns } from "./Observation.vue?vue&type=template&id=6e60b33e&scoped=true"
import script from "./Observation.vue?vue&type=script&lang=js"
export * from "./Observation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e60b33e",
  null
  
)

export default component.exports